import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR, IconWithTooltip } from '../../Icon'
import Text from '../../Text'

import * as styles from './IdwellToIdwellSubMenuCompanyListItem.module.css'

import ReconnectIcon from '../../../icons/connection-failed.svg'

function IdwellToIdwellSubMenuCompanyListItem({
  children,
  className = styles.IdwellToIdwellSubMenuCompanyListItem,
  isActive,
  item,
  selected,
  onClick,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const textClassName = classNames(styles.text, {
    [styles.disabled]: !isActive,
    [styles.selected]: selected,
  })

  function handleClick() {
    if (isActive) {
      onClick(item)
    }
  }

  return (
    <div className={className} onClick={handleClick}>
      <FloatingTooltip content={children} disabled={!overflow}>
        <Text
          className={textClassName}
          disabled={!isActive}
          ref={setContentOverflowRef}
        >
          {children}
        </Text>
      </FloatingTooltip>

      {isActive ? null : (
        <IconWithTooltip
          Icon={ReconnectIcon}
          color={ICON_COLOR.Red}
          tooltip={t('IdwellToIdwell.FailConnectionKey')}
        />
      )}
    </div>
  )
}

export default IdwellToIdwellSubMenuCompanyListItem
